import React from "react";
import { CloseButton } from "react-bootstrap";
import FocusTrap from "focus-trap-react";
import { IModal } from "../../interfaces/Components/Modal/IModal";
import "./modal.scss";

export const Modal: React.FC<IModal> = ({
  title, showBackdrop = true, closeOnClickAway = true, closeEvent, children, closeColour, ...props
}) => {
  const backdropClassName = `backdrop ${!showBackdrop ? "hidden" : ""}`;

  const closeHandler = () => {
    if (closeOnClickAway) closeEvent();
  };

  const getBackdropComponent = () => (closeOnClickAway
    ? <button type="button" aria-label="Close modal" className={backdropClassName} onClick={closeHandler} />
    : <div className={backdropClassName} />);

  return (
    <FocusTrap>
      <div role="dialog" aria-modal="true" className={`modal ${props.className}`} aria-label={title}>
        {getBackdropComponent()}

        <div className="modal-content" data-testid="modal-content">
          <div className="modal-header">
            <div className="modal-title h4">{title}</div>
            <CloseButton variant={closeColour} type="button" className="btn-close" onClick={closeEvent} aria-label="Close" />
          </div>
          <div className="modal-body">
            {children}
          </div>
        </div>
      </div>
    </FocusTrap>
  );
};
